import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

// core styles
import './scss/volt.scss';

// vendor styles
// TODO: Optimize this?
import '@fortawesome/fontawesome-free/css/all.css';

import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Slide, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ApiProvider } from './api/api';
import './assets/css/custom.css';
import FuncChat from './components/Chat';
import ScrollToTop from './components/ScrollToTop';
import TrialNotification from './components/TrialNotification';
import HomePage from './pages/HomePage';

const queryClient = new QueryClient();

ReactDOM.render(
  <BrowserRouter>
    <ApiProvider>
      <QueryClientProvider client={queryClient}>
        <TrialNotification />
        <ScrollToTop />
        <FuncChat />
        <HomePage />
        <ToastContainer position={toast.POSITION.BOTTOM_RIGHT} transition={Slide} />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ApiProvider>
  </BrowserRouter>,
  document.getElementById('root')
);
